module.exports = __webpack_public_path__ + "img/VL_11_02.1d00786e.png";